<template>
  <div class="app-main-content">
    <h1>Registration fee estimate</h1>
    <p>
      Listed below is an estimated fee of the Registration cost that will be incurred to register the vehicle with the
      plate type you listed on the previous page as of <span>{{ today }}</span>. Please read the disclaimer below for additional
      information on this quote.
    </p>

    <EstimateFee />

    <EstimateDisclaimer />

    <BaseButtonGroup>
      <template #default>
        <button @click="onBack">
          Back
        </button>
        <button class="app-btn-primary" @click="onPrint">
          Print
        </button>
      </template>
    </BaseButtonGroup>
  </div>
</template>

<script>
import appConfig from '@/app.config'
import EstimateFee from "../../components/modules/quote/EstimateFee"
import EstimateDisclaimer from "../../components/modules/quote/EstimateDisclaimer"
import BaseButtonGroup from "../../components/ui/BaseButtonGroup"
import { toDay } from "../../utils/helpers";

export default {
  name: "QuoteEstimate",
  page: {
    title: `Registration Fee Estimate | ${appConfig.shortName}`,
    meta: [
      {
        name: 'description',
        content: 'Get an estimated fee of the Registration cost that will be incurred to register the vehicle ' +
            'with a selected plate type on a given date.'
      }
    ]
  },
  components: {
    EstimateFee,
    EstimateDisclaimer,
    BaseButtonGroup,
  },
  computed: {
    today() {
      return toDay();
    }
  },
  methods: {
    onBack() {
      this.$router.push({ name: 'QuoteLookup' });
    },
    onPrint() {
      window.print();
    },
  }
}
</script>

<style lang="scss" scoped>
span {
  @extend %font-sans-bold;
}
</style>
